import { render, staticRenderFns } from "./InfoOrder.vue?vue&type=template&id=39b768d7"
import script from "./InfoOrder.vue?vue&type=script&lang=js"
export * from "./InfoOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports